import angular from 'angular'

export default angular.module('empresas', ['ui.router'])



// WEBPACK FOOTER //
// ./src/empresas/module.js